export function formatName(familyName?: string, givenName?: string) {
    return `${familyName} ${givenName}`;
}
